import React from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled from 'styled-components';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var MainContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  width: auto;\n  display: flex;\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
});
var RadioButtonLabel = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  cursor: ", ";\n"])), function (p) {
  return p.theme.palette.black;
}, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
var RadioButtonLabelText = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 20px;\n  margin-left: 24px;\n  color: ", ";\n"])), function (p) {
  return p.disabled ? p.theme.palette.gray['500'] : p.theme.palette.black;
});
var InputContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n\n  input {\n    opacity: 0;\n    height: 0;\n    width: 0;\n  }\n\n  span {\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    border: 1px solid ", ";\n    border-radius: 50%;\n  }\n\n  input:not(:checked):hover:enabled + span {\n    border: 1px solid ", ");\n  }\n\n  input:checked + span {\n    border-color: ", ";\n  }\n\n  input:checked:hover:enabled + span {\n    border-color: ", ";\n  }\n\n  input:checked:hover:enabled + span:after {\n    background-color: ", ";;\n  }\n\n  span:after {\n    display: none;\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n    width: 8px;\n    height: 8px;\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n    background: ", ";\n  }\n\n  input:checked ~ span:after {\n    display: block;\n  }\n"])), function (p) {
  return p.theme.palette.gray['400'];
}, function (p) {
  return p.theme.palette.gray['600'];
}, function (p) {
  return p.theme.palette.blue['600'];
}, function (p) {
  return p.theme.palette.blue['800'];
}, function (p) {
  return p.theme.palette.blue['800'];
}, function (p) {
  return p.theme.palette.blue['600'];
});

var _excluded = ["label", "className", "disabled"];
function Radio(_ref) {
  var label = _ref.label,
      className = _ref.className,
      disabled = _ref.disabled,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(MainContainer, {
    className: className
  }, /*#__PURE__*/React.createElement(RadioButtonLabel, {
    disabled: disabled
  }, /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement("input", _extends({
    type: "radio",
    disabled: disabled
  }, otherProps)), /*#__PURE__*/React.createElement("span", null)), label && /*#__PURE__*/React.createElement(RadioButtonLabelText, {
    disabled: disabled
  }, label))));
}

export { Radio };
